import styled from 'styled-components';

export const Value = styled.div`
  font-size: 0.875rem;
  font-weight: 400;
  p {
    color: ${(props) => props.theme.colors.textWhite};
  }
`;
